export const skills = [
  "Java", "Spring Boot", "JavaScript", "React", "Elixir", "Phoenix", "NodeJS", "Go"
]